export const SearchDivider = () => (
  <div className="my-3 w-px self-stretch bg-slate-100" />
);
